if (window.matchMedia( "(max-width: 767px)" ).matches) {
  var startScroll = 0;
  window.addEventListener('scroll', () => {
  	var elm = $(".look_inner > .popup-link:first-child");
  	var scroll = elm.get(0).getBoundingClientRect().top * -1;
  	
  	if(scroll < startScroll ){
          $('.section-header').removeClass('hide');
  	}else{
  		$('.section-header').addClass('hide');
  	}
  	startScroll = elm.get(0).getBoundingClientRect().top * -1;
  	
  }, true);
}	